/**
 * Estatus de entrega de MOBICO (Excel de ENTREGAS, lo guarda
 * PROCESSES_MX/save-mobico-orders en fuel_orders.delivery_status) → etiqueta
 * corta de la columna "Estatus del viaje". Compartido por el Cronograma
 * (pipes) y el modal de la pipa de Inventario (stock) para que digan lo mismo.
 * Unifica los estatus del reporte viejo (TRANSITO CARGADO…) y del nuevo
 * "Relación de viajes" (TRT, EN RUTA…); uno desconocido se muestra
 * capitalizado, no se oculta.
 */
const DELIVERY_STATUS_LABELS: Record<string, string> = {
  // Nombres cortos (revisión 06-oct): la celda mide 78px y "Rumbo a terminal"
  // / "Revisión docs." se cortaban con "…".
  PENDIENTE: "Pendiente",
  "RUMBO A TERMINAL": "A terminal",
  "EN TERMINAL": "En terminal",
  "REVISION DOCUMENTACION": "En revisión",
  CARGANDO: "Cargando",
  "TRANSITO CARGADO": "En ruta",
  TRT: "En ruta",
  "EN RUTA": "En ruta",
  "EN ESTACION": "En estación",
  ENTREGADA: "Entregada",
  // "Relación de viajes" (oct-2026) cierra el viaje como Finalizado, no Entregada.
  FINALIZADO: "Finalizada",
  CANCELADO: "Cancelada",
  "SIN ESTATUS": "Sin estatus",
};

export function deliveryStatusKey(row: any): string {
  return row?.delivery_status ? String(row.delivery_status).trim().toUpperCase() : "";
}

/** Estatus del Excel de ENTREGAS que cierran el viaje. Misma lista que el API
 *  (InventoryManagment DELIVERED_TRIP_STATUSES): el calendario y el modal de la
 *  pipa deben decir lo mismo. */
const DELIVERED_TRIP_KEYS = ["ENTREGADA", "FINALIZADO"];

/** Pipa del flujo MOBICO que de verdad LLEGÓ (jefe 15-oct): litros capturados Y el
 *  Excel la cerró. Con litros pero sin confirmación sigue «En proceso». */
export function isDeliveredTrip(row: any): boolean {
  return row?.liters != null && DELIVERED_TRIP_KEYS.includes(deliveryStatusKey(row));
}

export function deliveryStatusLabel(row: any, capitalize: (text: string) => string): string {
  const key = deliveryStatusKey(row);
  if (!key) {
    return "—";
  }
  // "DESCARGA…" (descargando en estación) llegó después del Excel de
  // referencia y su texto completo no cabe en la celda de 78px.
  if (key.startsWith("DESCARG")) {
    return "Descarga";
  }
  return DELIVERY_STATUS_LABELS[key] || capitalize(key.toLowerCase());
}

/** Pill del estatus con los colores del Excel de entregas (revisión 06-oct):
 *  el archivo solo resalta en AMARILLO "En Ruta" y "Revision Documentacion"
 *  (viajes en camino o atorados en papeles); los demás van sin color, en el
 *  gris neutro del pill. Cancelada conserva el rojo del portal y lo entregado
 *  va en verde. */
export function deliveryStatusClass(row: any): string {
  const key = deliveryStatusKey(row);
  if (key === "CANCELADO") {
    return "status-rejected";
  }
  // Entregada / Finalizada en verde (pedido de Edey 06-oct): el viaje cerró
  // bien. Mismo soft-tint verde de "Confirmada" del portal.
  if (key === "ENTREGADA" || key === "FINALIZADO") {
    return "status-confirmed";
  }
  if (["EN RUTA", "TRT", "TRANSITO CARGADO", "REVISION DOCUMENTACION"].includes(key)) {
    return "status-trip-alert";
  }
  return "";
}
